import React, { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import {
  createSupplier,
  findSupplierById,
  updateSupplierById,
} from "../../../../api/inventoryService";
import CloseIcon from "@mui/icons-material/Close";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import BusinessIcon from "@mui/icons-material/Business";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";

function AddSupplier({ closeModal, id }: any) {
  const methods = useForm();

  const onSubmit = (data: any) => {
    if (id) {
      updateSupplierById(id, data)
        .then(() => {
          methods.reset();
          closeModal();
        })
        .catch((error) => console.error(error?.response));
    } else {
      createSupplier(data)
        .then(() => {
          methods.reset();
          closeModal();
        })
        .catch((error) => console.error(error?.response));
    }
  };

  useEffect(() => {
    if (!id) return;
    findSupplierById(id)
      .then((data) => methods.reset(data as Record<string, unknown>))
      .catch((error) => console.error(error?.response));
  }, [id, methods]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
      <div className="bg-white dark:bg-slate-800 rounded-[8px] shadow-2xl w-full max-w-md overflow-hidden">
        {/* Header */}
        <div className="px-3 py-2 border-b border-slate-200 dark:border-slate-600 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 bg-amber-100 dark:bg-amber-900/40 rounded-md flex items-center justify-center">
              <LocalShippingIcon className="text-amber-600 dark:text-amber-300" sx={{ fontSize: 14 }} />
            </div>
            <h2 className="text-xs font-bold text-slate-800 dark:text-slate-100">
              {id ? "Edit Supplier" : "Add Supplier"}
            </h2>
          </div>
          <button
            onClick={closeModal}
            className="w-6 h-6 rounded-md bg-slate-100 dark:bg-slate-700 hover:bg-slate-200 dark:hover:bg-slate-600 flex items-center justify-center text-slate-600 dark:text-slate-300 transition-colors"
          >
            <CloseIcon sx={{ fontSize: 14 }} />
          </button>
        </div>

        {/* Form */}
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <div className="p-3 space-y-3">
              <div>
                <label className="block text-xs font-medium text-slate-700 dark:text-slate-300 mb-1">
                  <div className="flex items-center gap-1">
                    <BusinessIcon sx={{ fontSize: 14 }} />
                    Company Name
                  </div>
                </label>
                <input
                  {...methods.register("suppliercompany")}
                  type="text"
                  placeholder="Enter company name"
                  className="w-full px-3 py-2 bg-slate-50 dark:bg-slate-700 border border-slate-200 dark:border-slate-600 rounded-lg focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-all text-xs text-slate-800 dark:text-slate-200 placeholder:text-slate-400 dark:placeholder:text-slate-500"
                />
              </div>

              <div>
                <label className="block text-xs font-medium text-slate-700 dark:text-slate-300 mb-1">
                  <div className="flex items-center gap-1">
                    <PersonIcon sx={{ fontSize: 14 }} />
                    Supplier Name
                  </div>
                </label>
                <input
                  {...methods.register("supplierName")}
                  type="text"
                  placeholder="Enter supplier name"
                  className="w-full px-3 py-2 bg-slate-50 dark:bg-slate-700 border border-slate-200 dark:border-slate-600 rounded-lg focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-all text-xs text-slate-800 dark:text-slate-200 placeholder:text-slate-400 dark:placeholder:text-slate-500"
                />
              </div>

              <div>
                <label className="block text-xs font-medium text-slate-700 dark:text-slate-300 mb-1">
                  <div className="flex items-center gap-1">
                    <EmailIcon sx={{ fontSize: 14 }} />
                    Email
                  </div>
                </label>
                <input
                  {...methods.register("email")}
                  type="email"
                  placeholder="Enter email"
                  className="w-full px-3 py-2 bg-slate-50 dark:bg-slate-700 border border-slate-200 dark:border-slate-600 rounded-lg focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-all text-xs text-slate-800 dark:text-slate-200 placeholder:text-slate-400 dark:placeholder:text-slate-500"
                />
              </div>

              <div>
                <label className="block text-xs font-medium text-slate-700 dark:text-slate-300 mb-1">
                  <div className="flex items-center gap-1">
                    <PhoneIcon sx={{ fontSize: 14 }} />
                    Contact Number
                  </div>
                </label>
                <input
                  {...methods.register("phoneNumber")}
                  type="text"
                  placeholder="Enter contact number"
                  className="w-full px-3 py-2 bg-slate-50 dark:bg-slate-700 border border-slate-200 dark:border-slate-600 rounded-lg focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-all text-xs text-slate-800 dark:text-slate-200 placeholder:text-slate-400 dark:placeholder:text-slate-500"
                />
              </div>
            </div>

            {/* Footer */}
            <div className="px-3 py-2 border-t border-slate-200 dark:border-slate-600 flex justify-end gap-2">
              <button
                type="button"
                onClick={closeModal}
                className="px-4 py-2.5 text-slate-600 dark:text-slate-300 bg-white dark:bg-slate-700 border border-slate-200 dark:border-slate-600 rounded-lg hover:bg-slate-50 dark:hover:bg-slate-600 transition-colors font-medium text-xs"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-4 py-2.5 bg-gradient-to-r from-primary to-primaryLight text-white rounded-lg hover:shadow-lg hover:shadow-primary/20 transition-all font-medium text-xs"
              >
                {id ? "Update" : "Submit"}
              </button>
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  );
}

export default AddSupplier;
